export function formatMoney(value: number, hideUnit: boolean = false): string {
    if (value == undefined || value == null)
        return "";
    let isNegative = value < 0;
    let parts = (Math.abs(value) + "").split(".");
    let inteiro = parts[0];
    let decimal = ((parts[1] || 0) + Array(2 + 1).join("0")).substr(0, 2);
    return (!hideUnit ? "R$ " : "") + (isNegative ? "-" : "") + inteiro.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + "," + decimal;
};

export function moneyFormatToValue(value: string) {
    var newValueAsNum = +value.replace(/[^0-9,]/g, "").replace(",", ".");
    if (isNaN(newValueAsNum))
        newValueAsNum = 0;
    var roundingMultiplier = Math.pow(10, 2);
    return Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;
}

